<template>
  <div>
    <el-dialog
      :title="planData.title"
      :visible.sync="planData.show"
      width="1000px"
      center
    >
      <el-form
        :model="formData"
        label-width="130px"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item :label="$t('Proposal')" prop="Name">
          <el-input
            :disabled="disabledType"
            clearable
            v-model="formData.Name"
            maxlength="30"
            :placeholder="$t('EnterPlanName')"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('CalculationModel')">
              <el-select
                :disabled="disabledType"
                style="width: 100%"
                clearable
                v-model="formData.ModelId"
                :placeholder="$t('CalculationModel')"
              >
                <el-option :label="$t('UnlimitedForAll')" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('SettlementPeriod')">
              <el-select
                disabled
                style="width: 100%"
                clearable
                v-model="formData.cycle"
                :placeholder="$t('SettlementPeriod')"
              >
                <el-option label="日" value="日"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('ApplicableGameTypesPlan')">
          <el-button @click="selectType" type="primary">{{ $t('TypeSelection') }}</el-button>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('HashCommissionRate')+'(U)'" prop="rate.haxiusdt">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.haxiusdt"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('HashCommissionRate')+'(T)'" prop="rate.haxitrx">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.haxitrx"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('LiveCasinoCommissionRate')" prop="rate.live">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.live"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ElectronicCommissionRate')" prop="rate.dianzi">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.dianzi"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="20"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('SportsCommissionRat')" prop="rate.sport">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.sport"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="20"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('PokerCommissionRate')" prop="rate.qipai">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.qipai"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('BlockchainCommissionRate')" prop="rate.chain">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.chain"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('LotteryCommissionRate')" prop="rate.lottery">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.lottery"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('TexasHoldEmCommissionRate')" prop="rate.texas">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.texas"
                placeholder="请配置"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Low-frequencyLottery')" prop="rate.lowLottery">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.lowLottery"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('CryptoMarketCommissionRate')" prop="rate.cryptoMarket">
              <el-input
                :disabled="disabledType"
                v-model="formData.rate.cryptoMarket"
                :placeholder="$t('PleaseEnter')"
                type="number"
                :max="2"
                :min="0"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label-width="0px">
          <div>{{ $t('CommissionFormula') }}</div>
        </el-form-item>
        <el-form-item
          v-if="!disabledType"
          :label="$t('GoogleVerificationCode')"
          prop="GoogleCode"
        >
          <el-input
            v-model="formData.GoogleCode"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span v-if="!disabledType" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('ruleForm')"
          >{{$t('Save')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- 类型选择 -->
    <el-dialog
      :title="$t('ApplicableTypeConfiguration')"
      :visible.sync="showType"
      width="600px"
      center
    >
      <!-- <div>方案名称：98代理方案(121123123321312)</div> -->
      <div class="game-box" v-for="(item, index) in gameList" :key="index">
        <template v-if="item.game.length">
          <div class="item-title">
            <span>{{ item.name }}</span>
            <span>
              <el-checkbox
                :disabled="disabledType"
                @change="changeCheckedAll(item)"
                v-model="item.checked"
                >{{ $t('SelectAll') }}</el-checkbox
              >
              <el-checkbox
                :disabled="disabledType"
                @change="fanCheckedAll(item)"
                v-model="item.fanChecked"
                >{{$t('ReverseSelection')}}</el-checkbox
              >
            </span>
          </div>
          <div class="item-game">
            <el-checkbox
              :disabled="disabledType"
              @change="changeItem(item)"
              v-for="(i, index1) in item.game"
              :key="index1"
              v-model="i.checked"
              >{{ i.name }}</el-checkbox
            >
          </div>
        </template>
      </div>
      <span v-if="!disabledType" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSelectType">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  props: {
    planData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        Id: "",
        Name: "",
        ModelId: 1,
        cycle: "日",
        GoogleCode: "",
        State: 1,
        rate: {
          chain: 0.02,
          dianzi: 0.02,
          haxiusdt: 0.02,
          haxitrx: 0.02,
          live: 0.02,
          lottery: 0.02,
          texas: 0.02,
          qipai: 0.02,
          sport: 0.02,
          lowLottery: 0.02,
          cryptoMarket: 0.02,
        },
      },
      gameList: [
        {
          id: 1,
          state: 1,
          name: "哈希竞猜",
          text: "haxi",
          checked: false,
          fanChecked: false,
          game: [
            {
              id: 1,
              name: this.$t('textFilter.gameList1'),
              state: 1,
              checked: false,
            },
            {
              id: 2,
              name: this.$t('textFilter.gameList2'),
              state: 1,
              checked: false,
            },
            {
              id: 3,
              name: this.$t('textFilter.gameList3'),
              state: 1,
              checked: false,
            },
            {
              id: 4,
              name: this.$t('textFilter.gameList4'),
              state: 1,
              checked: false,
            },
            {
              id: 5,
              name: this.$t('textFilter.gameList5'),
              state: 1,
              checked: false,
            },
            {
              id: 6,
              name: this.$t('textFilter.gameList6'),
              state: 1,
              checked: false,
            },
            {
              id: 7,
              name: this.$t('textFilter.gameList7'),
              state: 1,
              checked: false,
            },
            {
              id: 11,
              name:this.$t('textFilter.gameList9'),
              state: 1,
              checked: false,
            },
            {
              id: 12,
              name: this.$t('textFilter.gameList8'),
              state: 1,
              checked: false,
            },
            {
              id: 101,
              name: "一分大小",
              state: 1,
              checked: false,
            },
            {
              id: 102,
              name: "一分单双",
              state: 1,
              checked: false,
            },
            {
              id: 103,
              name: "一分幸运",
              state: 1,
              checked: false,
            },
            {
              id: 104,
              name: "一分庄闲",
              state: 1,
              checked: false,
            },
            {
              id: 105,
              name: "一分牛牛",
              state: 1,
              checked: false,
            },
            {
              id: 131,
              name: "三分大小",
              state: 1,
              checked: false,
            },
            {
              id: 132,
              name: "三分单双",
              state: 1,
              checked: false,
            },
            {
              id: 133,
              name: "三分幸运",
              state: 1,
              checked: false,
            },
            {
              id: 134,
              name: "三分庄闲",
              state: 1,
              checked: false,
            },
            {
              id: 135,
              name: "三分牛牛",
              state: 1,
              checked: false,
            },
            {
              id: 201,
              name: "余额大小",
              state: 1,
              checked: false,
            },
            {
              id: 202,
              name: "余额单双",
              state: 1,
              checked: false,
            },
            {
              id: 203,
              name: "幸运余额",
              state: 1,
              checked: false,
            },
            {
              id: 204,
              name: "余额庄闲",
              state: 1,
              checked: false,
            },
            {
              id: 205,
              name: "余额牛牛",
              state: 1,
              checked: false,
            },
            {
              id: 301,
              name: "一分哈希大小",
              state: 1,
              checked: false,
            },
            {
              id: 302,
              name: "一分哈希单双",
              state: 1,
              checked: false,
            },
            {
              id: 331,
              name: "三分哈希大小",
              state: 1,
              checked: false,
            },
            {
              id: 332,
              name: "三分哈希单双",
              state: 1,
              checked: false,
            },
          ],
        },
        {
          id: 2,
          state: 1,
          name: this.$t('Blockchain'),
          text: "chain",
          checked: false,
          fanChecked: false,
          game: this.onGetCompanyList(this.$global.EGameType.E_Arcade),
        },
        {
          id: 3,
          state: 1,
          name: this.$t('common.comFooter.game4'),
          text: "qipai",
          checked: false,
          fanChecked: false,
          game: this.onGetCompanyList(this.$global.EGameType.E_Table),
        },
        {
          id: 4,
          state: 1,
          name: this.$t('common.comFooter.game5'),
          text: "live",
          checked: false,
          fanChecked: false,
          game: this.onGetCompanyList(this.$global.EGameType.E_Live),
        },
        {
          id: 5,
          state: 1,
          Name: this.$t('common.comFooter.game1'),
          text: "dianzi",
          checked: false,
          fanChecked: false,
          game: this.onGetCompanyList(this.$global.EGameType.E_Slots),
        },
        {
          id: 6,
          state: 1,
          name:this.$t('vip.detail.list3'),
          text: "lottery",
          checked: false,
          fanChecked: false,
          game: this.onGetCompanyList(this.$global.EGameType.E_Hash),
        },
        {
          id: 7,
          state: 1,
          name:this.$t('vip.detail.list5'),
          text: "sport",
          checked: false,
          fanChecked: false,
          game: this.onGetCompanyList(this.$global.EGameType.E_Sport),
        },
        {
          id: 8,
          state: 2,
          name: this.$t('Poker'),
          text: "texas",
          checked: false,
          fanChecked: false,
          game: [
            {
              id: "idn",
              name: "idn德州",
              state: 2,
              checked: false,
            },
          ],
        },
      ],
      dataList: [],
      showType: false,
      subData: {},
      rules: {
        Name: [
          {
            required: true,
            message:this.$t('EnterPlanName'),
            trigger: ["blur", "change"],
          },
        ],
        "rate.haxiusdt": [
          {
            required: true,
            message: "请输入哈希佣金比例(U)",
            trigger: ["blur", "change"],
          },
        ],
        "rate.haxitrx": [
          {
            required: true,
            message: "请输入哈希佣金比例(T)",
            trigger: ["blur", "change"],
          },
        ],
        "rate.live": [
          {
            required: true,
            message: "请输入真人佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.dianzi": [
          {
            required: true,
            message: "请输入电子佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.sport": [
          {
            required: true,
            message: "请输入体育佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.qipai": [
          {
            required: true,
            message: "请输入棋牌佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.chain": [
          {
            required: true,
            message: "请输入区块链佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.lottery": [
          {
            required: true,
            message: "请输入彩票佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.texas": [
          {
            required: true,
            message: "请输入德州扑克佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.lowLottery": [
          {
            required: true,
            message: "请输入低频彩佣金比例",
            trigger: ["blur", "change"],
          },
        ],
        "rate.cryptoMarket": [
          {
            required: true,
            message: "请输入CryptoMarket佣金比例",
            trigger: ["blur", "change"],
          },
        ],

        GoogleCode: [
          {
            required: true,
            message: this.$t('EnterGoogleVerificationCode'),
            trigger: ["blur", "change"],
          },
        ],
      },
      disabledType: false,
    };
  },
  created() {
    if (this.planData.type == 3) this.disabledType = true;
    if (this.planData.type == 2 || this.planData.type == 3) {
      this.formData.Name = this.planData.rowData.Name;
      this.formData.Id = this.planData.rowData.Id;
      this.formData.State = this.planData.rowData.State;
      let obj = JSON.parse(this.planData.rowData.Data);
      let rate = obj.rate;
      for (const key in rate) {
        rate[key] = app.getNumDecimal(rate[key] * 100);
      }
      this.formData.rate = { ...obj.rate };
      // console.log(obj.game)
      for (const key in obj.game) {
        this.gameList.forEach((item) => {
          if (key == item.text) {
            if (item.game.length) {
              item.game.forEach((ele) => {
                for (const key1 in obj.game[key]) {
                  if (ele.id == key1) {
                    ele.checked = obj.game[key][key1] == 1 ? true : false;
                  }
                }
              });
            }
          }
        });
      }
    } else {
      for (const key in this.formData.rate) {
        this.formData.rate[key] = app.getNumDecimal(
          Number(this.formData.rate[key]) * 100
        );
      }
    }
  },
  methods: {
    onGetCompanyList(pGameType) {
      let tList = app.GetCompany(pGameType);
      let tRetList = [];
      if (tList) {
        for (let i = 0; i < tList.length; ++i) {
          let tItem = tList[i];
          if (!tItem) {
            continue;
          }
          let tNewItem = {};
          tNewItem.id = tItem.Key;
          tNewItem.name = tItem.Name;
          tNewItem.state = 2;
          tNewItem.checked = false;
          tRetList.push(tNewItem);
        }
      }
      return tRetList;
    },
    // 新增
    add() {
      let rate = JSON.parse(JSON.stringify(this.formData.rate));
      for (const key in rate) {
        if (rate[key] > 2.5 || rate[key] < 0)
          return this.$message.warning("佣金比例范围为0～2.5之间");
        rate[key] = Number(rate[key]) / 100;
      }
      let result = {
        rate,
        game: this.subData,
      };
      const data = {
        SellerId: this.filters.SellerId,
        Name: this.formData.Name,
        ModelId: Number(this.formData.ModelId),
        State: Number(this.formData.State),
        GoogleCode: this.formData.GoogleCode,
        Data: JSON.stringify(result),
      };
      app.post("/agent/add_config_t1", data, (res) => {
        if (res.code == 200) {
          this.planData.show = false;
          this.$message.success("新增成功");
          this.$emit("success");
        }
      });
    },
    // 编辑
    edit() {
      this.subData = {
        haxi: {},
        dianzi: {},
        qipai: {},
        live: {},
        sport: {},
        lottery: {},
        chain: {},
        texas: {},
      };
      this.gameList.forEach((item) => {
        for (const key in this.subData) {
          if (item.text == key) {
            if (item.game.length) {
              item.game.forEach((ele) => {
                this.subData[key][ele.id] = ele.checked ? 1 : 0;
              });
            }
          }
        }
      });
      let rate = JSON.parse(JSON.stringify(this.formData.rate));
      for (const key in rate) {
        if (rate[key] > 2.5 || rate[key] < 0)
          return this.$message.warning("佣金比例范围为0～2.5之间");
        rate[key] = Number(rate[key]) / 100;
      }
      let result = {
        rate,
        game: this.subData,
      };
      const data = {
        Id: this.formData.Id,
        SellerId: this.filters.SellerId,
        Name: this.formData.Name,
        ModelId: Number(this.formData.ModelId),
        State: Number(this.formData.State),
        GoogleCode: this.formData.GoogleCode,
        Data: JSON.stringify(result),
      };
      app.post("/agent/modify_config_t1", data, (res) => {
        if (res.code == 200) {
          this.planData.show = false;
          this.$message.success(this.$t('EditSuccess'));
          this.$emit("success");
        }
      });
    },
    submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.planData.type == 1) this.add();
          if (this.planData.type == 2) this.edit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    selectType() {
      this.showType = true;
    },
    // {{ $t('SelectAll') }} 
    changeCheckedAll(item) {
      item.game.forEach((i) => {
        i.checked = item.checked;
      });
    },
    // 反选
    fanCheckedAll(item) {
      item.game.forEach((i) => {
        i.checked = !i.checked;
      });
      item.checked = item.game.every((i) => i.checked);
    },
    changeItem(item) {
      item.checked = item.game.every((i) => i.checked);
    },
    submitSelectType() {
      this.showType = false;
      this.subData = {
        haxi: {},
        dianzi: {},
        qipai: {},
        live: {},
        sport: {},
        lottery: {},
        chain: {},
        texas: {},
      };
      this.gameList.forEach((item) => {
        for (const key in this.subData) {
          if (item.text == key) {
            if (item.game.length) {
              item.game.forEach((ele) => {
                this.subData[key][ele.id] = ele.checked ? 1 : 0;
              });
            }
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.game-box .item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.item-game {
  border: 1px dashed #ccc;
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 10px;
}

.el-checkbox {
  margin-right: 10px;
}
</style>
